<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-calendar-alt"></i>&nbsp;<ng-container i18n>Export Calendar</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body" style="outline: none">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-12" *ngIf="isChannelNameRequired">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            matInput
            placeholder="Channel Name"
            i18n-placeholder
            formControlName="channelName"
            maxlength="50"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let name of availableChannelNames$ | async" [value]="name">
              {{ name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.get('channelName').touched && form.get('channelName').hasError('required')">
            <ng-container i18n>Channel name is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('channelName').touched && form.get('channelName').hasError('maxlength')">
            <ng-container i18n>Channel name must be at most 50 characters long</ng-container>
          </mat-error>
          <mat-hint align="end">{{ form.get('channelName').value.length || 0 }}/50</mat-hint>
        </mat-form-field2>
      </div>

      <div class="col-sm-12" *ngIf="channels$">
        <app-select-search
          bindLabel="friendlyName"
          [inline]="false"
          [multiple]="false"
          [items]="channels$ | async"
          [ctrl]="form.get('channel')"
          placeholder="Channel"
          i18n-placeholder
        >
          <ng-container class="error-container">
            <mat-error> <ng-container i18n>Channel is required</ng-container> </mat-error>
          </ng-container>
        </app-select-search>
      </div>

      <div class="col-sm-12" *ngIf="rentals$">
        <app-rental-select
          [multiple]="false"
          [ctrl]="form.get('rental')"
          [bindValue]="selectRental"
          placeholder="Rental"
          i18n-placeholder
        >
        </app-rental-select>
      </div>
      <div class="col-sm-12">
        <div class="alert alert-secondary-info">
          <i class="fal fa-info-circle alert-icon"></i>
          <div class="alert-content" i18n>
            Please select the AdvanceCM rental whose iCal URL you would like to export. You can undo this setting later
            if you wish.
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="create(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="fal fa-check"></i> <ng-container i18n>Export</ng-container>
  </button>
</div>
